






import { Component, Mixins, Provide, Prop, Watch } from 'vue-property-decorator';
import MixinCharts from '../../../plugins/podolib/services/helper/mixins/chart/standard';
import { SeriesOptionsTypeExtended, TChart } from '../../../plugins/podolib/services/helper/mixins/chart';

@Component
export default class ChartRunningPhaseSpeedCadenceComparison extends Mixins(MixinCharts) implements TChart {
  @Prop({ default: 'speed' }) type!: string;
  @Prop({ default: '' }) firstAcquisitionDate!: string;
  @Prop({ default: '' }) secondAcquisitionDate!: string;

  @Provide() readonly name = 'ChartRunningPhaseSpeedCadenceComparison';

  get isSpeedType() {
    return this.type === 'speed';
  }

  get segments() {
    /*const data = this.values.segments.filter(
      (x: any) => x.left.aggregates.stance_time.avg !== 0 && x.right.aggregates.stance_time.avg !== 0
    );*/
    return this.values.segments;
  }
  get segments_compare() {
    return this.compareValues.segments;
  }

  get speed() {
    let data: any = [];
    this.segments.forEach((item: any, idx: number) => {
      data.push([
        this.getDuration(item),
        (item.left.result.aggregates.running_speed.avg + item.right.result.aggregates.running_speed.avg) / 2,
      ]);
    });
    return data;
  }
  get speed_compare() {
    let data: any = [];
    this.segments_compare.forEach((item: any, idx: number) => {
      data.push([
        this.getDuration(item),
        (item.left.result.aggregates.running_speed.avg + item.right.result.aggregates.running_speed.avg) / 2,
      ]);
    });
    return data;
  }

  get cadence() {
    let data: any = [];
    this.segments.forEach((item: any, idx: number) => {
      data.push([
        this.getDuration(item),
        item.left.result.aggregates.cadence.avg + item.right.result.aggregates.cadence.avg,
      ]);
    });
    return data;
  }
  get cadence_compare() {
    let data: any = [];
    this.segments_compare.forEach((item: any, idx: number) => {
      data.push([
        this.getDuration(item),
        item.left.result.aggregates.cadence.avg + item.right.result.aggregates.cadence.avg,
      ]);
    });
    return data;
  }

  get _val_compare(): SeriesOptionsTypeExtended[] {
    return this.type === 'speed'
      ? [
          // @ts-ignore
          {
            id: 'Speed',
            name: this.getDate(this.firstAcquisitionDate),
            data: this.speed,
            zones: [],
            type: 'spline',
            shadow: true,
            color: '#2A60FF',
            marker: {
              enabled: false,
            },
          },
          // @ts-ignore
          {
            id: 'Comparison',
            name: this.getDate(this.secondAcquisitionDate),
            data: this.speed_compare,
            zones: [],
            type: 'spline',
            shadow: true,
            color: '#50e5b1',
            marker: {
              enabled: false,
            },
          },
        ]
      : [
          // @ts-ignore
          {
            id: 'Cadence',
            name: this.getDate(this.firstAcquisitionDate),
            data: this.cadence,
            zones: [],
            type: 'spline',
            shadow: true,
            color: '#2A60FF',
            marker: {
              enabled: false,
            },
          },
          // @ts-ignore
          {
            id: 'Comparison',
            name: this.getDate(this.secondAcquisitionDate),
            data: this.cadence_compare,
            zones: [],
            type: 'spline',
            shadow: true,
            color: '#50e5b1',
            marker: {
              enabled: false,
            },
          },
        ];
  }
  get series() {
    return [...this._val_compare];
  }

  @Watch('values', { deep: true, immediate: true })
  onValuesChange() {
    this.setData();
  }

  getDate(val: string) {
    return `${this.$moment(val).format('DD-MM-YYYY')} • ${this.$moment(val).format('HH:mm')}`;
  }
  getDuration(item: any) {
    // let globalSpeed = (item.left.header.start_time + item.right.header.start_time) / 2;
    return (this.$moment as any)
      .duration({
        seconds: item.left.header.start_time / 32768,
      })
      .asMilliseconds();
  }
  getDurationByIndex(idx: number) {
    return (this.$moment as any)
      .duration({
        seconds: this.segments[idx].left.header.start_time / 32768,
      })
      .asMilliseconds();
  }
  setData() {
    let _this = this;
    this.setOptions({
      chart: {
        height: this.height || 230,
      },
      title: {
        text: _this.$t('commons.standards.cadence') + ' / ' + _this.$t('commons.standards.speed'),
        style: {
          fontSize: '0',
        },
      },
      exporting: {
        enabled: false,
      },
      xAxis: {
        labels: {
          formatter() {
            // @ts-ignore
            return _this.$moment.utc(this.value).format('mm:ss');
          },
        },
        crosshair: {
          width: 25,
          color: 'rgba(212, 246, 255, 0.5)',
        },
      },
      yAxis: {
        labels: {
          format: `{value}`,
        },
        title: {
          // @ts-ignore
          enabled: false,
          text: _this.isSpeedType
            ? _this.$t('commons.standards.speed') + ' (km/h)'
            : _this.$t('commons.standards.cadence') + ' (' + _this.$t('commons.units.steps-min') + ')',
        },
        min: _this.isSpeedType ? 3 : 100,
      },
      plotOptions: {
        // @ts-ignore
        areaspline: {
          lineWidth: 3,
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1,
            },
            stops: [
              [0, 'rgba(131,212,255, 0.5)'],
              [1, 'rgba(212, 246, 255, 0.2)'],
            ],
          },
        },
        spline: {
          lineWidth: 3,
        },
      },
      tooltip: {
        distance: 50,
        // @ts-ignore
        crosshairs: true,
        shared: true,
        followPointer: true,
        formatter: function () {
          let s = `<span style="font-size: 15px;">${_this.$moment
            // @ts-ignore
            .utc(_this.getDurationByIndex(this.points![0].point!.index))
            .format('mm:ss')} min </span>`;
          s += `<span style="font-size: 13px; color:grey">${_this.$moment
            // @ts-ignore
            .utc(_this.getDurationByIndex(this.points![0].point!.index))
            .format('SS')} ms</span>`;
          s += `<br/><span>-</span><br/>`;
          for (const p of this.points!) {
            const isCadence = p.series.name === _this.$t('commons.standards.cadence');
            s += `<span style="font-size: 13px; font-weight: bold; color: ${p.color}">${
              p.series.name
            } : ${p.point.y!.toFixed(isCadence ? 0 : 1)} ${
              isCadence ? _this.$t('commons.units.steps-min') : 'km/h'
            }</span>`;
            s += `<br/>`;
          }
          return s;
        },
      },
      series: [],
    });
    this.setSeries(this.series);
  }

  created() {
    this.setData();
  }
}
